import script from "./NoData.vue?vue&type=script&setup=true&lang=js"
export * from "./NoData.vue?vue&type=script&setup=true&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=28dffe01&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28dffe01"]])

export default __exports__